module.exports = __webpack_public_path__ + "static/yourrole_icon-26432f9a8559b2f4a4cacd17fe64e9e7.svg";